import { Component } from '@angular/core';

@Component({
  selector: 'app-organizer-flow-section',
  imports: [],
  templateUrl: './organizer-flow-section.html',
  styleUrl: './organizer-flow-section.css',
})
export class OrganizerFlowSection {}
